import { render, staticRenderFns } from "./fogetPasswordForm.vue?vue&type=template&id=07391aa8&"
import script from "./fogetPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./fogetPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./fogetPasswordForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports